
import { Placement } from '@post-office/placements-frontend/jira-software-currency-field-recommendations';
export default Placement;
